module.exports = __webpack_public_path__ + "static/media/Endodoncia.29d16dce.png";